import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

export default function BadShipmentsList(props){
    //console.debug("RTS Break BadShipmentsList");
    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    
    function handleClick(e, cellValues){
        history("/ReelsEdit", {state: { idGuid:cellValues.row.reelIdGuid, 
                                        display:cellValues.row.reel!=null?cellValues.row.reel:'N/A',
                                        displayExt:cellValues.row.reel!=null?cellValues.row.reel:'N/A', 
                                        mode:1}});
    }


    const columns = [
        {
            field: '',
            description:"Edit Reel", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'shipDate', 
            headerName: "Ship Date", 
            description:"Load Ship Date", 
            flex:2,
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },

        },                           
        {
            field: 'reel', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
            flex:3,
        },
        {
            field: 'reelType', 
            headerName: "Reel Type", 
            description:"Reel Type", 
            flex:3,
        },
        {
            field: 'soldToCustomerName', 
            headerName: "Sold To Customer", 
            description:"Sold To Customer Name", 
            flex:4,
        },
        {
            field: 'soldToCustomerIdSap', 
            headerName: "Sold To Id", 
            description:"Sold To Customer Id", 
            flex:3,
        },        {
            field: 'productName', 
            headerName: "Product", 
            description:"Product Name", 
            flex:4,
        },
        {
            field: 'productIdSap', 
            headerName: "Product Id", 
            description:"Product Id", 
            flex:4,
        },
        {
            field: 'customerPo', 
            headerName: "Customer PO", 
            description:"Customer PO", 
            flex:3,
        },
        {
            field: 'idSapOrder', 
            headerName: "SAP Order", 
            description:"SAP Order", 
            flex:3,
        },
        {
            field: 'idSapBol', 
            headerName: "BOL", 
            description:"Bill of Lading", 
            flex:3,
        },
        {
            field: 'idSapPackingList', 
            headerName: "Packing List", 
            description:"Packing List", 
            flex:3,
        },
        {
            field: 'idSapBatchNo', 
            headerName: "Batch No.", 
            description:"Batch Number", 
            flex:3,
        }          
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {productName:false, productIdSap:false, customerPo:false, idSapOrder:false, idSapBol:false, idSapPackingList:false, idSapBatchNo:false}
        }
        else{
            return {productName:false, productIdSap:false, customerPo:false, idSapOrder:false, idSapBol:false, idSapPackingList:false, idSapBatchNo:false}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}